import type { GpuContext } from '../context.js';
import { workgroupCount } from '../context.js';
import type { GpuImage } from '../resources.js';
import { Struct } from '../uniform-writer.js';

export const COMBINE_RGB_ALPHA_R = 0;
export const COMBINE_MASK = 1;
export const COMBINE_ATTENUATE = 2;
export const COMBINE_COPY = 3;
export const COMBINE_UNPREMULTIPLY = 4;
export const COMBINE_PREMULTIPLY = 5;
export const COMBINE_RGB_ALPHA_A = 6;
export const COMBINE_BROADCAST_R = 7;
export const COMBINE_EXTRACT_ALPHA = 8;

export type CombineMode =
  | typeof COMBINE_RGB_ALPHA_R
  | typeof COMBINE_MASK
  | typeof COMBINE_ATTENUATE
  | typeof COMBINE_COPY
  | typeof COMBINE_UNPREMULTIPLY
  | typeof COMBINE_PREMULTIPLY
  | typeof COMBINE_RGB_ALPHA_A
  | typeof COMBINE_BROADCAST_R
  | typeof COMBINE_EXTRACT_ALPHA;

/** Channel plumbing between stages; see `combine.wgsl` for the mode table. */
export function combine(
  ctx: GpuContext,
  a: GpuImage,
  b: GpuImage,
  dst: GpuImage,
  mode: CombineMode,
): void {
  ctx.dispatch(
    {
      module: 'combine.wgsl',
      defines: { DST_FORMAT: dst.format },
      bindings: [
        { kind: 'texture', format: a.format },
        { kind: 'texture', format: b.format },
        { kind: 'storageTexture', format: dst.format },
        { kind: 'uniform' },
      ],
    },
    [a, b, dst, ctx.uniform(new Struct(16).i(0, dst.width, dst.height).u(8, mode, 0).bytes)],
    [workgroupCount(dst.width, 8), workgroupCount(dst.height, 8)],
    `combine mode=${mode}`,
  );
}

/** Straight copy / format conversion. */
export function copyImage(ctx: GpuContext, src: GpuImage, dst: GpuImage): void {
  combine(ctx, src, src, dst, COMBINE_COPY);
}
